import { Result } from 'antd'
import React from 'react'

function ClosedRequest({ remark }) {
    return (
        <div>
            <Result
                status="success"
                title="Request Closed"
                subTitle={`Remarks : ${remark}`}

            ></Result>
        </div>
    )
}

export default ClosedRequest